package app

import kotlinx.serialization.Serializable

@Serializable
data class AppProperties(var apiEndpoint: String = "", var mapsKey : String = "",
             var shuffleQuestions: Boolean = false, var properties: Map<String, String> = emptyMap()) {

}
